import React from 'react';

// Gold-shimmer skeleton primitives — replace spinners for content blocks. Match final layout to avoid CLS.
export const Skeleton = ({ className = '' }) => (
  <div className={`skeleton-shimmer ${className}`} aria-hidden="true" />
);

export const SkeletonProductCard = () => (
  <div className="group block" aria-hidden="true">
    <Skeleton className="aspect-[3/4] w-full" />
    <div className="pt-4 flex flex-col items-center gap-2.5">
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-5 w-40" />
      <Skeleton className="h-3 w-16" />
      <div className="flex gap-1.5 mt-1">
        {Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} className="h-4 w-4 rounded-full" />)}
      </div>
    </div>
  </div>
);

export const SkeletonProductGrid = ({ count = 8 }) => (
  <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8" data-testid="skeleton-grid">
    {Array.from({ length: count }).map((_, i) => <SkeletonProductCard key={i} />)}
  </div>
);

export const SkeletonPDP = () => (
  <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10 grid lg:grid-cols-2 gap-10 lg:gap-16" data-testid="skeleton-pdp">
    <Skeleton className="aspect-[3/4] w-full" />
    <div className="flex flex-col gap-4 lg:pt-4">
      <Skeleton className="h-4 w-28" />
      <Skeleton className="h-12 w-3/4" />
      <Skeleton className="h-4 w-40" />
      <Skeleton className="h-8 w-32 mt-2" />
      <Skeleton className="h-24 w-full mt-2" />
      <div className="flex gap-2 mt-4">
        {Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} className="h-11 w-14" />)}
      </div>
      <Skeleton className="h-14 w-full mt-6" />
    </div>
  </div>
);
